import { Injectable } from '@angular/core'
import { MainApi, Configuration, PrivateApi, AutomationApi, AIApi, ClickApi, AuthApi, MediaLibraryApi, SharedstorageApi, StorageApi, IntegrationsApi, TapeArchiveApi, ApiResponse } from 'elements-sdk'
import { HttpInterceptorService } from './interceptor.service'

export interface PaginationState {
  first: number
  last: number,
  total: number,
}

@Injectable({ providedIn: 'root' })
export class APIService {
  private configuration = new Configuration({
    basePath: '',
    fetchApi: async (input, init?) => {
      const request = new Request(input, init)
      return this._interceptor.processResponse(request, await fetch(request))
    },
  })

  readonly ai = new AIApi(this.configuration)
  readonly auth = new AuthApi(this.configuration)
  readonly automation = new AutomationApi(this.configuration)
  readonly click = new ClickApi(this.configuration)
  readonly integrations = new IntegrationsApi(this.configuration)
  readonly main = new MainApi(this.configuration)
  readonly mediaLibrary = new MediaLibraryApi(this.configuration)
  readonly private = new PrivateApi(this.configuration)
  readonly sharedStorage = new SharedstorageApi(this.configuration)
  readonly storage = new StorageApi(this.configuration)
  readonly tapeArchive = new TapeArchiveApi(this.configuration)

  constructor (private interceptor: HttpInterceptorService) { }

  private get _interceptor (): HttpInterceptorService {
    return this.interceptor
  }

  extractPagination (response: ApiResponse<any>): PaginationState|undefined {
    const contentRange = response.raw.headers.get('Content-Range')
    if (contentRange?.startsWith('items ')) { // DRF
      const [first, last, total] = contentRange.split(' ')[1].split(/[/-]/g).map(x => parseInt(x))
      return {
        first: first - 1,
        last: last - 1,
        total,
      }
    }
    return undefined
  }
}
